(function () {
  'use strict';

  const STORAGE_KEY = 'v2_popup_seen';

  function init(popup) {
    if (popup.dataset.v2PopupInit === 'true') return;
    popup.dataset.v2PopupInit = 'true';

    const trigger = popup.dataset.trigger || 'delay';
    const delay = parseInt(popup.dataset.delay, 10) || 6;
    const frequency = popup.dataset.frequency || 'once';

    // Frequency check
    function alreadyShown() {
      if (frequency === 'always') return false;
      if (frequency === 'session') {
        try { return sessionStorage.getItem(STORAGE_KEY) === '1'; } catch (e) { return false; }
      }
      // once
      try { return localStorage.getItem(STORAGE_KEY) === '1'; } catch (e) { return false; }
    }

    function markShown() {
      try {
        if (frequency === 'session') sessionStorage.setItem(STORAGE_KEY, '1');
        else if (frequency === 'once') localStorage.setItem(STORAGE_KEY, '1');
      } catch (e) {}
    }

    if (alreadyShown()) return;

    // Open / close
    function open() {
      if (popup.classList.contains('is-open')) return;
      popup.removeAttribute('hidden');
      popup.setAttribute('aria-hidden', 'false');
      // reflow for transition
      // eslint-disable-next-line no-unused-expressions
      popup.offsetHeight;
      popup.classList.add('is-open');
      document.documentElement.style.overflow = 'hidden';
      document.body.style.overflow = 'hidden';
      document.documentElement.classList.add('v2-popup-lock');
      document.body.classList.add('v2-popup-lock');
      markShown();
      const focusable = popup.querySelector('.v2-popup__input, [data-popup-close]');
      if (focusable) setTimeout(() => focusable.focus({ preventScroll: true }), 100);
    }

    function close() {
      popup.classList.remove('is-open');
      popup.setAttribute('aria-hidden', 'true');
      document.documentElement.style.overflow = '';
      document.body.style.overflow = '';
      document.documentElement.classList.remove('v2-popup-lock');
      document.body.classList.remove('v2-popup-lock');
      setTimeout(() => popup.setAttribute('hidden', ''), 400);
    }

    // Bind close
    popup.querySelectorAll('[data-popup-close]').forEach((el) => {
      el.addEventListener('click', (e) => {
        e.preventDefault();
        close();
      });
    });

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && popup.classList.contains('is-open')) close();
    });

    // Triggers
    if (trigger === 'delay') {
      setTimeout(open, delay * 1000);
    } else if (trigger === 'exit') {
      const onLeave = (e) => {
        if (e.clientY <= 0 || (e.relatedTarget === null && e.y <= 5)) {
          open();
          document.removeEventListener('mouseleave', onLeave);
        }
      };
      // Wait a bit before arming
      setTimeout(() => {
        document.addEventListener('mouseleave', onLeave);
      }, 2000);
    } else if (trigger === 'scroll') {
      const onScroll = () => {
        const scrolled = window.scrollY / (document.documentElement.scrollHeight - window.innerHeight);
        if (scrolled >= 0.3) {
          open();
          window.removeEventListener('scroll', onScroll);
        }
      };
      window.addEventListener('scroll', onScroll, { passive: true });
    }

    // Success state if form posted successfully (Shopify reloads with ?customer_posted=true)
    if (window.location.search.indexOf('customer_posted=true') !== -1) {
      const form = popup.querySelector('.v2-popup__form-wrap');
      const success = popup.querySelector('[data-popup-success]');
      if (form && success) {
        success.removeAttribute('hidden');
        popup.classList.add('is-success');
        // Force open even if previously shown
        try { localStorage.removeItem(STORAGE_KEY); } catch (e) {}
        try { sessionStorage.removeItem(STORAGE_KEY); } catch (e) {}
        open();
      }
    }

    // Copy discount code
    popup.querySelectorAll('[data-popup-copy]').forEach((btn) => {
      btn.addEventListener('click', () => {
        const code = btn.dataset.popupCopy;
        if (navigator.clipboard && code) {
          navigator.clipboard.writeText(code).then(() => {
            const orig = btn.textContent;
            btn.textContent = 'Copiado ✓';
            btn.classList.add('is-copied');
            setTimeout(() => {
              btn.textContent = orig;
              btn.classList.remove('is-copied');
            }, 2000);
          });
        }
      });
    });
  }

  function boot() {
    document.querySelectorAll('[data-v2-popup]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
